/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * KO resource file
 */
export const labels = {
	title: 'EY Canvas Economics',
	status: '상태',
	header: '머리글',
	canvas: 'Canvas',
	canvasEconomics: 'Canvas Economics',
	badRequest: '잘못된 요청',
	errorBanner: '{0}개 오류',
	userProfileDropdown: {
		myProfile: '내 프로필',
		signOut: '로그아웃'
	},
	clientCode: '고객 코드',
	hours: '시간',
	local: '로컬',
	currency: '통화',
	rate: '요율',
	forecast: '예측',
	variance: '변동',
	edit: '편집',
	arrowUp: '위쪽 화살표',
	budget: '예산',
	priorBudget: '전기 예산',
	currentBudget: '당기 예산',
	summary: '요약',
	actual: '실제',
	priorActual: '전기 실제',
	currentActual: '당기 실제',
	remaining: '나머지',
	adjustment: '조정',
	estimate: '추정치',
	isRequired: '{0}은(는) 필수입니다',
	isPositiveInteger: '{0}은(는) 필수이며 음이 아닌 정수여야 합니다',
	isPositiveDecimal: '{0}은(는) 필수이며 소수점 이하 두 자리인 양수여야 합니다',
	in: 'In',
	id: 'ID',
	currentYear: '당기',
	priorYear: '전기',
	budgetHierarchy: '예산 체계',
	executionBudgetHierarchy: '실행 예산 체계',
	noContentAvailable: '사용 가능한 내용 없음',
	viewMore: '더 보기',
	budgetExecutionPhase: '{0} 내 모든 object에 대한 예산',
	details: '세부정보',
	unallocated: '미배정',
	none: '없음',
	thousands: '천',
	millions: '백만',
	lakhs: '십만',
	crores: '천만',
	budgetObjectName: '예산 Object 이름',
	editActivityCodes: 'Activity 코드 편집',
	save: '저장',
	send: 'Send',
	cancel: '취소',
	searchActivityCodes: 'Activity 코드 검색',
	noActivityCodesAvailable: '사용 가능한 activity 코드 없음',
	select: '선택',
	engagementCode: 'Engagement 코드',
	engagementCodeName: 'Engagement code name',
	activityCode: 'Activity 코드',
	activityCodeDescription: 'Activity 코드 설명',
	searchActivityCodesPlaceholderText: 'Activity 코드 검색',
	addMember: '멤버 추가',
	closeLabel: '닫기',
	cancelLabel: '취소',
	seachInputRequired: '검색 입력 필요',
	nameOrEmail: '이름 또는 이메일',
	emailForExternal: '이메일',
	noRecord: '결과를 찾을 수 없습니다',
	userSearchPlaceholder: '결과를 보려면 이름이나 이메일을 입력하고 Enter 키를 누르십시오',
	userSearchPlaceholderForExternal: '이메일을 입력하고 Enter 키를 눌러 결과를 보십시오',
	clearAllValues: '모든 값 처리',
	clear: '처리',
	inValidEmail: '유효한 이메일을 입력하십시오',
	invalidClientCode: '유효하지 않은 고객 코드',
	railSearchText: '검색',
	open: 'Open',
	remove: '제거',
	leave: '나가기',
	delete: '삭제',
	markAsCompleted: '완료 표시',
	budgetedHours: '예산 시간',
	forecastedHours: '예측 시간',
	actualHours: '실제 시간',
	ftaVariance: 'FTA 차이',
	ftaVarianceTooltip: '예측 대 실적 차이',
	usedHours: '사용 시간',
	etcHours: 'ETC 시간',
	createProjectCard: '프로젝트 생성',
	plusClients: '+{0} 고객',
	plusCodes: '+{0} 고객 코드',
	clientNames: '고객 이름:',
	clientName: '고객 이름:',
	clientNameLabel: 'Client name',
	clientCodes: '고객 코드:',
	clientCodeCard: '고객 코드:',
	financialAnalysis: 'Financial analysis',
	billingExpenses: '청구 & 비용',
	independence: 'Independence',
	timeChargedCanvasIndependenceStatus: 'Overall Project Independence Status by EY Canvas and Financial Code',
	independenceStatusFromCanvasLabel:'Independence status from EY Canvas',
	independenceRequired: 'Independence required',
	validatedCanvas: 'Validated in EY Canvas',
	notInvited: 'Not invited',
	notApplicable: 'Not applicable',
	incomplete: 'Incomplete',
	other: "Other",
	financialCodesDisplayed: "Financial codes displayed",
	independenceStatusChangeReasonLabel: "Change status",
	independenceStatusChangeReasonDescription: "Select completion reason for selected team member",
	changeReasonLabel: 'Reason',
	clarificationLabel: 'Clarification (optional)',
	characterCount: '{0} of 200 characters',
	expandAll: "Expand all",
	collapseAll: "Collapse all",
	canvasEngagements: "EY Canvas engagements",
	independenceCompleted: 'Independence completed',
	engagementName: 'Engagement name',
	engagementIndependenceStatus: 'By engagement independence status',
	noAssociatedClients:'No associated client',
	noCanvasEngagementsIdentified:'No EY Canvas engagements identified',
	placeholderForSearch:'Search Team Member',
	exportToExcel: 'Export to Excel',
	all: 'All',
	updateSelected: 'Update selected',
	updateAll: 'Update all',
	customizeTable: 'Customize table',
	canvasEngagementName: 'EY Canvas engagement name',
	displayBy: '데이터 표시 기준',
	financialDetails: '세부재무정보',
	actualHoursToDate: '누적 실제 시간',
	byWeekEndingDate: '주 종료일 기준',
	ClickAndDrag: '확대하려면 차트에서 영역을 클릭한 후 끌어당기십시오',
	etc: '완료 예상 시간',
	auditProgress: 'EY Canvas progress',
	tasksAndMilestones: 'Task & Milestone',
	milestonesOverdue: 'Milestone 지연',
	milestoneOverdue: 'Milestone 지연',
	inProgress: '진행 중',
	inReview: '리뷰 중',
	Complete: '완료',
	assignments: '배정',
	assignment: '배정',
	assignmentsOverdue: '배정 지연',
	assignmentOverdue: '배정 지연',
	overdue: '지연',
	requestOverdue: '요청 지연',
	requestsOverdue: '요청사항 지연',
	total: '합계',
	complete: '완료',
	closed: '닫힘',
	Unassigned: '배정되지 않음',
	unassigned: '배정되지 않음',
	sent: '전송됨',
	totalTask: '총 Task',
	collaboration: '공동작업',
	received: '수신됨',
	accepted: '수락됨',
	outstanding: '처리 전',
	unsentDrafts: '미전송 초안',
	draft: '초안',
	drafts: '초안',
	returned: 'returned',
	draftRequests: '초안 요청사항',
	percent: '퍼센트',
	preparer: '작성자',
	reviewer: '검토자',
	NoDataForSelectedOptions: 'No information available for the selected options.',
	NoAssignmentDataForSelectedOptions: 'Engagement is not using the Assignment feature',
	NoCollabDataForSelectedOptions: 'Engagement에서 공동작업 기능을 사용하지 않습니다',
	tasks: 'Task',
	totalTasks: '총 task',
	requests: '요청사항',
	requestSent: '요청사항 전송됨',
	requestsSent: '요청사항 전송됨',
	expandDetails: '세부정보 확장',
	onlyProjectAdministratorsCanEdit: '프로젝트 관리자만 편집할 수 있습니다',
	onlyProjectAdministratorsCanDelete: '프로젝트 관리자만 프로젝트를 삭제할 수 있습니다',
	userOptions: '사용자 옵션',
	userOptionsDropdown: {
		userSettings: '사용자 설정',
		delegateAccess: '대리인 관리',
		privacyNotice:'Privacy notice',
		signOut: '로그아웃'
	},
	delegateToInstruction: '동료에게 접근권한을 위임하여, 귀하 대신 engagement를 검증하도록 합니다. 대리인은 귀하가 접근할 수 있는 engagement를 모두 검증할 수 있습니다.',
	delegateFromInstruction: '다음 사용자는 engagement 코드 검증 권한을 위임했습니다',
	delegateAccess: '대리인 관리',
	addDelegates: '대리인 추가',
	addAnother: '신규 대리인 추가',
	hideMyDelegate: '내 대리인 숨기기',
	showMyDelegate: '내 대리인 표시',
	duplicateUser: '대리인으로 이미 추가됨',
	informationRequired: '이 정보는 필수입니다',
	delegateTo: '위임받은 사람',
	delegateFrom: '위임한 사람',
	noDelegatesAdded: '추가된 대리인 없음',
	noDelegationReceived: '수신된 위임 없음',
	removeDelegateMessgae: '이 대리인을 제거하시겠습니까? 제거하고 나면, 더 이상 귀하를 대신해서 프로젝트를 생성할 수 없습니다.',
	removeDelegateTitle: '대리인 제거',
	delegate: '위임',
	saveAndClose: '저장 & 닫기',
	resetZoom: 'Reset zoom',
	exportData: 'Export data',
	rankCode: 'Rank code',
	userGui: 'User GUI',
	email: 'Email',
	globalAnsr: 'Global ANSR',
	globalCost: 'Global cost',
	globalMargin: 'Global margin',
	localAnsr: 'Local ANSR',
	localCost: 'Local cost',
	localMargin: 'Local margin',
	weekEnding: 'Week ending',
	welcomeToEconomics: 'Welcome to the EY Canvas Economics ',
	adminPortal: 'administrative portal',
	home: 'Home',
	enterFirstNameText:'Enter first name, last name or email address of user and press enter to search',
	addBtn: '추가',
	cancelBtn: 'Cancel',
	close: '닫기',
	selectRole: 'Role',
	upsText: 'Ups!',
	sufficientRightsToAccess: 'You do not have sufficient rights to access this page',
	detailedInformation : 'Detailed information may vary from summary data presented due to timing differences of when data is made available.',
	noResultFound: 'No results match the search criteria',
	loading: 'Loading...',
	search: '검색',
	softwareUpdate: 'Software updates',
	updateLater: 'Update later',
	updateNow: 'Update now',
	updateMsg: 'Software updates are available for EY Canvas Economics. Select Update Now to download and install the updates. The page will be refreshed.',
		
	eycanvasEngagements: 'EY Canvas engagements',
	eycanvasEngagement: 'EY Canvas engagement',
	expandView: 'Expand view',
	noFinancialCodesDisplay: 'No financial codes to display',
	expand: '확장',
	collapse: 'Collapse',
	bulkSendIndependenceLabel: 'Bulk send independence confirmation',
	independenceStatusInviteUserLabel: 'Add internal team member as Independence only',
	independenceStatusInviteUserDescription: "Identify the role of the team member below. This user will be added to {0} Canvas engagement with the 'Independence only' restrictions and will be notified to complete their Independence.",
	clickToInviteUser: 'to send independence confirmation',
	click: 'Click',
	invitePending:'Invite pending',
	engagementRolePlaceholder: 'Engagement role',
	engagementRoleRequiredErrorMessage: 'Please select the engagement role for the selected team member',
	engagementInvitationSuccessToastMessage: 'You have successfully sent the independence confirmation(s).',
	engagementInvitationFailureToastMessage: 'Failed to send the independence confirmation(s), Please retry. If issue persists, reach out to the Help desk.',
	independenceInviteConfirmationMessage: 'Independence confirmation has been sent. Response is pending.',
	engagementRoleRequiredOverAllErrorMessage: 'An engagement role has not been selected for one or more users. Select the engagement role from the drop down to proceed with sending the Independence confirmation.',
	administrativeContractor: 'Administrative contractor',
	notAvailable: 'Not Available',
	allocation: 'Allocation',
};

export const errors = {
	default: '오류가 발생했습니다. 헬프 데스크에 문의하십시오.',
	102: '유효하지 않은 프로젝트',
	106: 'RBAC 승인 거부됨',

	1001: '사용자를 찾을 수 없습니다',
	1002: '사용자 모두 가져오기 호출 실패',
	1003: '사용자 GUI는 null일 수 없습니다',
	1004: '요청은 null일 수 없습니다',
	1005: "GUI가 동일한 사용자가 이미 있기 때문에 사용자를 생성할 수 없습니다",
	1006: 'GUI가 동일한 사용자가 두 명 이상 발견됐습니다',
	1007: '사용자가 활동 상태가 아닙니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오',
	1008: '선택한 숫자 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오',
	1009: '선택한 반올림 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오',
	1010: '선택한 통화 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오',
	1011: '선택한 날짜 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오',
	1012: '선택한 언어 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오',
	1013: '이름이 너무 짧거나 너무 깁니다. 다시 시도하십시오.',
	1014: '성이 너무 짧거나 너무 깁니다. 다시 시도하십시오.',
	1015: '선택한 음수 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오',
	1016: "사용자가 존재하지 않기 때문에 사용자를 업데이트할 수 없습니다",
	1017: '사용자 기본 설정을 가져오는 동안 오류가 발생했습니다. API를 호출하지 못했습니다.',
	1018: '사용자를 생성하는 동안 오류가 발생했습니다. API를 호출하지 못했습니다.',
	1019: '사용자 기본 설정을 업데이트하는 동안 오류가 발생했습니다. API를 호출하지 못했습니다.',
	1020: '사용자가 활동 상태가 아닙니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	1021: '선택한 테마 값이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	1022: '선택한 통화 값이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	1023: '사용자는 요청한 팀 멤버를 프로젝트에서 제거할 권한이 없습니다',
	1024: '대리 사용자를 생성하는 동안 오류가 발생했습니다. API 호출에 실패했습니다.',
	1025: '대리 사용자 목록은 비워 둘 수 없습니다',
	1026: '사용자\ 이름이 너무 길거나 너무 짧습니다',
	1027: '사용자\ GUI가 유효하지 않습니다',
	1028: '사용자\ 이메일 주소가 너무 길거나 너무 짧습니다',
	1029: '사용자 ID는 비워 둘 수 없습니다',
	1030: '사용자 이름은 비워 둘 수 없습니다',
	1031: '사용자 이메일 주소는 비워 둘 수 없습니다',
	1032: '사용자는 접근권한을 제거할 컬렉션의 대리인에 속하지 않습니다',
	1033: '사용자는 접근권한을 제거할 컬렉션의 위임자에 속하지 않습니다',
	1034: '사용자는 콜렉션의 대리인에 이미 속해 있습니다',
	1035: '사용자 ID 길이가 적합하지 않습니다. 올바른 사용자 ID로 다시 시도하십시오.',
	1036: '로그인한 사용자는 목록에 속할 수 없습니다. 나중에 다시 시도하십시오.',
	1040: 'You do not have administrator rights. Please contact the help desk.',

	7001: 'Engagement 메타데이터 호출 실패',
	7006: '지금은 EY Canvas에 접속할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',

	8003: 'CDS API에서 Engagement 세부정보를 가져오는 동안 오류가 발생했습니다',
	8006: '지금은 EY Canvas에 접속할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	8004: 'Engagement 코드를 찾을 수 없습니다. Mercury 코드라면 Engagement 유형이 포함됐는지 확인하십시오. 다시 시도하고 문제가 지속되면 헬프 데스크에 문의하십시오.',
	8007: 'Error while getting Engagement Details from CDS API.',
	8008: 'Connection failed. Refresh and try again. If the issue persists, contact the Help desk.',

	9001: '요청은 null일 수 없습니다',
	9002: '프로젝트 고객 코드 필드는 null일 수 없습니다',
	9003: '프로젝트 이름 필드는 null일 수 없습니다',
	9004: '퍼센트 필드는 null일 수 없습니다',
	9005: '요율 필드는 null일 수 없습니다',
	9006: '예산에 선택한 참여가 연결되어 있지 않습니다',
	9007: 'Engagement 고유 식별자는 null일 수 없습니다',
	9008: 'Engagement 고객 이름은 null일 수 없습니다',
	9009: 'Engagement 설명은 null일 수 없습니다',
	9010: 'Engagement 고객 고유 식별자는 null일 수 없습니다',
	9011: '연결된 engagement 시스템은 null일 수 없습니다',
	9012: '연결된 engagement 고유 식별자는 null일 수 없습니다',
	9013: '연결된 engagement 이름은 null일 수 없습니다',
	9014: '연결된 engagement 고객 고유 식별자는 null일 수 없습니다',
	9015: '연결된 engagement 고객 이름은 null일 수 없습니다',
	9016: '연결된 engagement 추가한 사람은 null일 수 없습니다',
	9017: 'One or more EY Canvas engagements are invalid.',
	9018: 'One or more Related engagement Codes are invalid.',
	9019: "프로젝트 퍼센트는 0보다 커야 합니다",
	9020: "프로젝트 퍼센트는 소수점 이하 2자리를 넘지 않아야 합니다",
	9021: "프로젝트 요율은 0보다 커야 합니다",
	9022: '프로젝트 ID가 유효하지 않습니다',
	9023: 'Get call for financial analysis failed.',
	9024: '프로젝트 세부정보를 찾을 수 없습니다',
	9025: '머리글 호출 가져오기 실패',
	9026: 'No results match the search criteria.',
	9027: '유효하지 않은 집계 유형',
	9028: '현재 사용자는 프로젝트에 접근권한이 없습니다',
	9029: '프로젝트 청구 세부정보를 찾을 수 없습니다',
	9030: "Project Financial Filters not found.",
	9031: "A user's name is either too long or too short.",
	9032: "A user's GUI is invalid.",
	9033: "A user's email address is either too long or too short.",
	9034: 'At least one team member should have project administrator role.',
	9035: '귀하는 프로젝트의 마지막 활동 프로젝트 관리자입니다. 랜딩 페이지에서 프로젝트를 제거하려면 삭제하십시오. 프로젝트를 삭제할 수 없다면 헬프 데스크에 문의하십시오.',
	9036: 'Please remove some EY Canvas Engagement because the quantity exceeds the {0}.',
	9037: 'Please remove some team members because the quantity exceeds the {0}.',
	9038: 'Please remove some Engagement codes because the quantity exceeds the {0}.',
	9039: '프로젝트 사용자 수는 0보다 커야 합니다',
	9040: 'Unvalidated Financial Codes must not be null or empty strings, and their length cannot surpass 50 characters.',
	9041: '프로젝트 ID는 비워 둘 수 없습니다',
	9042: '삭제를 완료할 수 없습니다. 다시 시도하고 오류가 지속되면 헬프 데스크에 문의하십시오.',
	9043: '현재 사용자는 프로젝트 편집 권한이 없습니다',
	9044: 'Project Financial Details call failed.',
	9045: 'Project status is not valid.',
	9046: 'Project user status is not valid.',
	9047: 'Invalid project user role.',
	9048: 'Project name should be within 500 characters.',
	9049: 'Project user first name cannot be empty.',
	9050: 'Project user last name cannot be empty.',
	9051: 'Project user GUI cannot be empty.',
	9052: 'Project user email cannot be empty.',
	9053: 'Project user admin flag cannot be empty.',
	9054: 'Priviledged account cannot be added as project user.',
	9055: 'Project Expense Filters not found.',
	9056: 'Project indepedence patch request body cannot be empty.',
	9058: 'Financial codes is invalid.',
	9063: 'Independence complete has invalid rationale value.',
	9064: 'Independence complete type has invalid value.',
	9065: 'Project Expense Filters not found.',
	9066: 'Number of engagement ids linked to the project is greater than the maximum allowed number.',
	9067: 'Invalid patch operation.',
	9068: 'Some user already updated the status, refresh the page to view the latest status.',
	9069: 'Independence patch API failed.',
	9070: 'Duplicate financial codes associated to canvas engagement.',
	9071: 'Only single financial codes associated to canvas engagement can be marked as primary code.',
	9072: 'Primary financial codes associated to canvas engagements is invalid.',
	9073: 'Duplicate unvalidated financial codes.',
	9074: 'Duplicate users.',
	9075: 'A user Email is invalid.',
	9076: 'Engagement user creater request body cannot be empty.',
	9077: 'Engagement user create request has duplicate users.',
	9078: 'Engagement user role is invalid.',
	9079: 'Invalid canvas engagement.',
	9080: 'Engagement not mapped to project.',
	9081: 'Engagement user creation request failed.',
	9082: 'Session has been timed out due to inactivity. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Admin error codes*/
	14001: 'User not found',
	14002: 'Admin User call failed',
	14003: 'Admin user found is InActive',
	14004: 'Admin user creation failed',
	14005: 'The first name is either too short or too long. Please try again',
	14006: 'The last name is either too short or too long. Please try again',
	14007: 'Administrator role id is invalid',
	14008: 'The selected user is already an administrator. Please review.',
	14009: 'Admin user search call failed',
	14010: 'User gui cannot be empty',
	14011: 'User gui must be greater than zero',
	14012: 'User id is not valid. Please try again',
	14013: 'Email address is not valid. Please try again',
	14014: 'Logged in user is not same as admin user',
	14015: 'Admin project search call failed',
	14016: 'Admin user already exists but is InActive',
	14017: 'Admin can only be priviledged user account',
	14018: 'Administrator role id cannot be empty.',
	14019: 'Logged in user is not system admin.',
	14020: 'Invaid requestor privileged account.',
	14021: 'Admin can only be priviledged user account.',
	14023: 'Error removing existing admin roles.',
	14024: 'Error adding updated admin roles.',
	14025: 'Admin user id cannot be empty.',

	/*PAANS error codes*/
	15001: 'The EY Policy Authoring, Approvals and Notification Service​ is unavailable at this time.  We are unable to confirm if all relevant policies have been completed.  If you have not reviewed the relevant policies, refresh the page and try again.  If the issue persists, contact the Help Desk.'
};
export const roundingOptions = [{
		value: 'none',
		label: '없음'
	},
	{
		value: 'thousands',
		label: '천'
	},
	{
		value: 'millions',
		label: '백만'
	},
	{
		value: 'lakhs',
		label: '십만'
	},
	{
		value: 'crores',
		label: '천만'
	}
];

export const displayLanguages = [{
		displayLanguageId: 1,
		label: 'English',
		value: 'en-us'
	},
	{
		displayLanguageId: 4,
		label: 'Français',
		value: 'fr-ca'
	},
	{
		displayLanguageId: 5,
		label: 'Español',
		value: 'es'
	},
	{
		displayLanguageId: 7,
		label: 'Português',
		value: 'pt-br'
	},
	{
		displayLanguageId: 8,
		label: 'Japanese',
		value: 'ja'
	},
	{
		displayLanguageId: 9,
		label: 'Chinesezh-cn',
		value: 'zh-cn'
	},
	{
		displayLanguageId: 10,
		label: 'Chinesezh-tw',
		value: 'zh-tw'
	},
	{
		displayLanguageId: 11,
		label: 'Hebrew',
		value: 'he'
	},
	{
		displayLanguageId: 12,
		label: 'Korean',
		value: 'ko'
	},
];

export const numberFormats = [{
		value: '1,234,567,890',
		label: 'numbericStlye1',
		title: '1,234,567,890'
	},
	{
		value: '1.234.567.890',
		label: 'numbericStlye3',
		title: '1.234.567.890'
	},
	{
		value: '1,23,45,67,890',
		label: 'numbericStlye7',
		title: '1,23,45,67,890'
	},
	{
		value: '1 234 567 890',
		label: 'numbericStlye2',
		title: '1 234 567 890'
	}
];

export const dateFormats = [{
		value: 'MM/dd/yyyy',
		label: 'MM/DD/YYYY'
	},
	{
		value: 'dd/MM/yyyy',
		label: 'DD/MM/YYYY'
	},
	{
		value: 'yyyy/MM/dd',
		label: 'YYYY/MM/DD'
	}
];

export const negativeNumberFormats = [{
		value: '(1.1)',
		label: '(1.1)'
	},
	{
		value: '-1.1',
		label: '-1.1'
	},
	{
		value: '- 1.1',
		label: '- 1.1'
	},
	{
		value: '1.1-',
		label: '1.1-'
	},
	{
		value: '1.1 -',
		label: '1.1 -'
	}
];

export const currencyFormats = [{
		value: 'global',
		label: 'Global'
	},
	{
		value: 'local',
		label: 'Local'
	}
];

export const themeOptions = {
	light: '라이트',
	dark: '다크'
};

export const currencyOptions = {
	global: 'Global',
	local: '로컬'
};

export const currencyDisplayOptions = [{
		value: 'Global',
		label: 'Global'
	},
	{
		value: 'Local',
		label: 'Local'
	}
];

export const statusValues = [{
		isActive: true,
		label: 'Active'
	},
	{
		isActive: false,
		label: 'Inactive'
	}
];

export const financialOptions = {
	serviceLine: '서비스라인',
	subServiceLine: '서브서비스라인',
	teamMember: '팀 멤버',
	rank: '직급'
};

export const roles = {
	1: 'PARTNER IN CHARGE',
	2: 'Engagement Partner',
	3: 'Executive Director',
	4: 'PRINCIPAL',
	5: 'SENIOR MANAGER',
	6: 'Manager',
	7: 'SENIOR',
	8: 'Staff',
	9: 'Intern',
	10: 'Engagement Quality Reviewer',
	11: 'OTHER PARTNER',
	12: 'GDS - Staff',
	13: 'Advisory (ITRA,TAS,Human Capital or Other)',
	14: 'Tax',
	15: 'Executive Support Services',
	16: 'General Counsel',
	17: 'Audit Quality Reviewer',
	21: 'Internal Audit Supervisor',
	22: 'Internal Audit Staff',
	23: 'Regulator',
	24: 'Other (e.g. due diligence review)',
	25: 'Office',
	26: 'Area',
	27: 'Industry',
	28: 'National',
	29: 'Global',
	30: 'GDS - Senior',
	31: 'GDS - Manager'
};

export const serviceLines = [{
		value: 0,
		label: '모든 서비스라인'
	},
	{
		value: 1,
		label: 'Advisory'
	},
	{
		value: 2,
		label: 'Assurance'
	},
	{
		value: 3,
		label: 'GCO'
	},
	{
		value: 4,
		label: 'TAS'
	},
	{
		value: 5,
		label: 'Tax'
	},
	{
		value: 6,
		label: 'Other'
	}
];

export const serviceLinesByServiceLineCode = [{
		code: 'Not available',
		label: 'Not available'
	},
	{
		code: null,
		label: 'Allocation'
	},
	{
		code: 'ASU',
		label: 'Assurance'
	},
	{
		code: 'TAS',
		label: 'Strategy and Transactions'
	},
	{
		code: 'TAX',
		label: 'Tax'
	},
	{
		code: 'ADV',
		label: 'Consulting'
	},
];

export const userRanks = [{
		id: '11',
		name: 'Partner'
	},
	{
		id: '12',
		name: 'Partner'
	},
	{
		id: '13',
		name: 'Executive Director'
	},
	{
		id: '21',
		name: 'Sr. Manager'
	},
	{
		id: '32',
		name: 'Manager'
	},
	{
		id: '36',
		name: 'Tax Manager'
	},
	{
		id: '4',
		name: 'Contractor'
	},
	{
		id: '41',
		name: 'Senior 3'
	},
	{
		id: '42',
		name: 'Senior'
	},
	{
		id: '43',
		name: 'Staff 2'
	},
	{
		id: '44',
		name: 'Staff'
	},
	{
		id: '45',
		name: 'Senior 2'
	},
	{
		id: '46',
		name: 'Staff 3'
	},
	{
		id: '49',
		name: 'Associate'
	},
	{
		id: '5',
		name: 'Administrative contractor'
	},
	{
		id: '51',
		name: 'Intern'
	},
	{
		id: '52',
		name: 'Admin Support'
	},
	{
		id: '53',
		name: 'Intern (CBS)'
	},
	{
		id: '55',
		name: 'Admin Lead'
	},
	{
		id: '56',
		name: 'Admin Advanced'
	},
	{
		id: '57',
		name: 'Admin Intermediate'
	},
	{
		id: '58',
		name: 'Admin Entry'
	},
	{
		id: '61',
		name: 'Director'
	},
	{
		id: '62',
		name: 'Associate Director'
	},
	{
		id: '63',
		name: 'Assistant Director'
	},
	{
		id: '64',
		name: 'Supervising Associate'
	},
	{
		id: '65',
		name: 'Sr. Associate'
	},
	{
		id: '66',
		name: 'Associate'
	},
	{
		id: 'Not available',
		name: 'Not available'
	},
	{
		id: null,
		name: 'Allocation'
	},
];

export const financialAnalysis = {
	noResultFound: '선택한 옵션에 대한 결과를 찾을 수 없습니다',
	allServiceLines: '모든 서비스라인',
	allSubServiceLines: '모든 서브서비스라인',
	allMembers: '모든 멤버',
	allAvailable: '모두 가능',
	allAdded: '모두 추가됨',
	selectAll: '모두 선택',
	noResult: '결과를 찾을 수 없습니다',
	noneSelected: '선택한 항목 없음',
	clearAllSeleted: '# 선택 취소',
	showSelected: '선택 표시',
	allRanks: '모든 직급'
};

export const independenceStatus = [{
		value: 1,
		label: 'Incomplete - Not invited'
	},
	{
		value: 2,
		label: 'Incomplete - In progress'
	},
	{
		value: 3,
		label: 'Completed - Other'
	},
	{
		value: 4,
		label: 'Completed - Validated In EY Canvas'
	}
];

export const eycanvasIndependenceStatus = [{
		value: 1,
		label: 'Incomplete'
	},
	{
		value: 2,
		label: 'No Matters Identified'
	},
	{
		value: 3,
		label: 'Matter Identified - Pending Action'
	},
	{
		value: 4,
		label: 'Matter Resolved - Denied Access'
	},
	{
		value: 5,
		label: 'Matter Resolved - Granted Access'
	},
	{
		value: 6,
		label: 'Not Applicable'
	},
	{
		value: 7,
		label: 'Restored'
	},
	{
		value: 8,
		label: 'Override'
	},
	{
		value: 9,
		label: 'Prior - No Matters Identified'
	},
	{
		value: 10,
		label: 'Prior - Matter Identified - Pending Action'
	},
	{
		value: 11,
		label: 'Prior - Matter Resolved - Granted Access'
	},
	{
		value: 12,
		label: 'Prior - Matter Resolved - Denied Access'
	}
];

export const eycanvasIndependenceStatusAvailableOnUI = [{
		value: 1,
		label: 'Incomplete'
	},
	{
		value: 2,
		label: 'No Matters Identified'
	},
	{
		value: 3,
		label: 'Matter Identified - Pending Action'
	},
	{
		value: 4,
		label: 'Matter Resolved - Denied Access'
	},
	{
		value: 5,
		label: 'Matter Resolved - Granted Access'
	},
	{
		value: 6,
		label: 'Not Applicable'
	},
	{
		value: 7,
		label: 'Restored'
	},
	{
		value: 8,
		label: 'Override'
	},
	{
		value: 9,
		label: 'Prior - No Matters Identified'
	},
	{
		value: 11,
		label: 'Prior - Matter Resolved - Granted Access'
	},
	{
		value: 12,
		label: 'Prior - Matter Resolved - Denied Access'
	},
	{
		value: 13,
		label: 'Not Invited'
	}
];

export const availableUserRoles = [{
	  value: 1,
	  label: 'Partner in Charge',
	  displayOrder: 9
  },
  {
	  value: 2,
	  label: 'Engagement Partner',
	  displayOrder: 8
  },
  {
	  value: 3,
	  label: 'Executive Director',
	  displayOrder: 5
  },
  {
	  value: 4,
	  label: 'Principal',
	  displayOrder: 6
  },
  {
	  value: 5,
	  label: 'Senior Manager',
	  displayOrder: 4
  },
  {
	  value: 6,
	  label: 'Manager',
	  displayOrder: 3
  },
  {
	  value: 7,
	  label: 'Senior',
	  displayOrder: 2
  },
  {
	  value: 8,
	  label: 'Staff',
	  displayOrder: 1
  },
  {
	  value: 10,
	  label: 'Engagement Quality Reviewer',
	  displayOrder: 10
  },
  {
	  value: 11,
	  label: 'Other Partner',
	  displayOrder: 7
  },
  {
	  value: 12,
	  label: 'GDS - Staff',
	  displayOrder: 13
  },
  {
	  value: 16,
	  label: 'General Counsel',
	  displayOrder: 12
  },
  {
	  value: 17,
	  label: 'Audit Quality Reviewer',
	  displayOrder: 11
  },
  {
	  value: 30,
	  label: 'GDS - Senior',
	  displayOrder: 14
  },
  {
	  value: 31,
	  label: 'GDS - Manager',
	  displayOrder: 15
  }
]

export const employmentStatusFilter = [{
		value: 'A',
		label: 'Active'
	},
	{
		value: 'L,P,U',
		label: 'Leave of absence'
	},
	{
		value: 'D,R,T',
		label: 'Terminated'
	}
]

export const employmentStatus = [{
		value: 'A',
		label: 'Active'
	},
	{
		value: 'D',
		label: 'Terminated'
	},
	{
		value: 'L',
		label: 'Leave of absence'
	},
	{
		value: 'T',
		label: 'Terminated'
	},
	{
		value: 'P',
		label: 'Leave of absence'
	},
	{
		value: 'R',
		label: 'Terminated'
	},
	{
		value: 'U',
		label: 'Leave of absence'
	},
]

export const independenceStatusDropdown = [{
		label: 'Incomplete',
		options: [{
				value: 1,
				label: 'Incomplete - Not invited'
			},
			{
				value: 2,
				label: 'Incomplete - In progress'
			}
		]
	},
	{
		label: 'Complete',
		options: [{
				value: 3,
				label: 'Completed - Other'
			}
		]
	}
];

export const customizedTableOptions = [{
		id: 2,
		label: 'EY Canvas independence status'
	},
	{
		id: 3,
		label: 'Member firm'
	},
	{
		id: 4,
		label: 'Country'
	},
	{
		id: 5,
		label: 'Hours charged'
	},
	{
		id: 6,
		label: 'Overall independence status'
	},
	{
		id: 7,
		label: 'Confirmation date'
	},
	{
		id: 8,
		label: 'Employment Status'
	},
	{
		id: 9,
		label: 'Updated by'
	},
	{
		id: 10,
		label: 'Updated date'
	}
];

export const independenceStatusChangeReasons = [{
		value: 1,
		label: 'Completed outside of EY Canvas - No Matters Identified',
		isDisplayed: true
	},
	{
		value: 7,
		label: 'Completed outside of EY Canvas - Matters Identified',
		isDisplayed: true
	},
	{
		value: 8,
		label: 'Completed outside of EY Canvas - Matters Resolved',
		isDisplayed: true
	},
	{
		value: 2,
		label: 'Always a covered person',
		isDisplayed: true
	},
	{
		value: 3,
		label: 'No longer with the Firm',
		isDisplayed: true
	},
	{
		value: 4,
		label: 'Leave of absence',
		isDisplayed: true
	},
	{
		value: 5,
		label: 'Terminated',
		isDisplayed: false
	},
	{
		value: 6,
		label: 'Other',
		isDisplayed: false
	}
];

export const common = {
	selected: '선택됨',
	cancel: '취소',
	checkbox: {
		selectAllOn: '모두 선택',
		selectAllOff: '모두 선택 해제'
	},
	clear: '처리',
	close: '닫기',
	nav: {
		projectName: 'Project name'
	},
	pagination: {
		show: '표시',
		iconHover: {
			first: '첫 페이지',
			previous: '이전 페이지',
			next: '다음 페이지',
			last: '마지막 페이지'
		}
	},
	search: {
		clear: '검색 처리',
		buttonTitle: '검색',
		placeholder: '검색',
		noResultsPlaceholder: '결과를 찾을 수 없습니다'
	},
	table: {
		remove: '제거',
		noDataPlaceholder: '사용 가능한 데이터 없음',
		noResultsPlaceholder: '결과를 찾을 수 없습니다'
	},
	toggleSwitch: {
		no: '아니오',
		yes: '예'
	},
	wizard: {
		next: '계속',
		back: '뒤로',
		finish: '마침'
	},
	unsavedChanges: 'Unsaved changes',
	unsavedChangesDescription: 'You have unsaved changes that will be lost if you choose to continue. Are you sure you want to undo your changes?'
};

export const project = {
	myProjects: '내 프로젝트',
	priorProjects: '전기 프로젝트',
	searchForBudgets: '검색',
	emptyContainer: '활성 예산이 없습니다. 시작하려면 "예산 생성"을 클릭하십시오.',
	noResultsFound: '결과를 찾을 수 없습니다',
	create: {
		title: '프로젝트 생성',
		clientCode: '고객 코드',
		clientCodeInfo: '미러 코드는 인식되지 않습니다. 코드를 발행한 시스템(즉, Mercury 또는 GFIS)의 코드를 사용하십시오.',
		clientName: '고객 이름',
		clientNamePlaceholder: '고객 이름을 찾으려면 고객 코드를 입력하십시오',
		name: '프로젝트 이름',
		rate: '시간당 기본 요율',
		rateInfo: '시간당 기본 요율은 예산 시간 가치를 계산하는 데 사용됩니다. 이 요율은 청구할 보수를 총 예상 시간으로 나눈 값으로 계산해야 합니다.',
		percentage: '예상 실현율',
		percentageInfo: '예상 실현율은 Mercury 또는 GFIS에 청구된 시간 가치에 적용됩니다',
		relateEngagementsInstructionalText: '이 프로젝트에 사용될 EY Canvas engagement를 하나 이상 선택하십시오. 이 engagement 지표는 재무 데이터와 함께 표시됩니다. 현재 접근 가능한 engagement만 표시됩니다.',
		selectClientAndWorkspaceInstructionalText: '이 프로젝트에 연결된 EY Canvas engagement를 식별하려면 고객과 workspace를 선택하십시오',
		engagementPanelPlaceholder: '권장 engagement를 표시하려면 고객과 workspace를 선택하십시오',
		engagementPanelNoResultsFound: '결과를 찾을 수 없습니다',
		emptyEngagements: '사용 가능한 EY Canvas engagement 없음. 시작하려면 EY Canvas에 신규 engagement를 생성하십시오.',
		selectClient: '고객 선택',
		selectWorkspace: 'Workspace를 선택하십시오',
		selectEngagements: 'Engagement 선택',
		selectedEngagements: '추가된 engagement',
		selectedEngagementError: '계속하려면 engagement를 하나 이상 선택하십시오',
		searchEngagements: 'Engagement 검색',
		searchUsers: '사용자 검색',
		engagementLabel: '{0} | ID: {1}',
		addBtn: '추가',
		removeBtn: '제거',
		clientLbl: '고객',
		engagementCodeLbl: 'Engagement 코드',
		engagementTypeCodeLbl: 'Engagement 유형',
		engagementNameLbl: 'Engagement 이름',
		engagementId: 'ID',
		addedByLbl: '추가한 사람',
		engagementDescriptionLbl: 'Engagement 설명',
		systemLbl: '시스템',
		noEngagementsLabel: 'Engagement 코드를 이 프로젝트에 연결',
		step4InstTxt: '프로젝트에 연결할 engagement 코드를 하나 이상 선택하십시오',
		relatedEngagementCodesSubtitle: '연결된 Engagement 코드',
		relatedEngagementCodeLink: 'Mercury 또는 GFIS의 engagement 코드 연결. 미러 코드는 인식되지 않습니다.',
		unauthorizedModalHeader: '권한 없는 사용자',
		unauthorizedText: '연결할 권한이 없습니다',
		allowedUsersText: '다음은 이 작업을 할 수 있는 사람 목록입니다',
		closeBtn: '닫기',
		validateBtn: '검증',
		relatedEngagementAddLabel: 'Mercury 또는 GFIS의 engagement 코드 연결. 미러 코드는 인식되지 않습니다.',
		todayLbl: '오늘',
		NoEmailMessage: '제공된 이메일 없음',
		noEngagementsAdded: '추가된 engagement 없음',
		selectToImport: '이 프로젝트에 사용자를 불러오려면 EY Canvas engagement를 선택하십시오',
		addMember: 'If a user is not active in the EY Canvas engagement, {0} to add them.',
		addedMembers: '추가된 멤버',
		employeeName: '멤버',
		role: '역할',
		manageTeamInstructionalText: '연결된 EY Canvas engagement에서 활동 팀 멤버를 선택하고 아래 설명에 따라 EY Canvas engagement에 속하지 않는 다른 팀 멤버를 추가하십시오',
		currentUser: '현재 사용자',
		canvasEngagements: 'EY Canvas engagements',
		wizardSteps: [{
				stepName: '단계 1',
				stepDescription: '프로젝트 세부정보 입력',
				active: true
			},
			{
				stepName: '단계 2',
				stepDescription: 'Select EY Canvas engagements'
			},
			{
				stepName: '단계 3',
				stepDescription: '접근 관리',
				relatedEngagementCodesSubtitle: '연결된 Engagement 코드',
				relatedEngagementCodeLink: 'Mercury 또는 GFIS의 engagement 코드 연결. 미러 코드는 인식되지 않습니다.',
				unauthorizedModalHeader: '권한 없는 사용자',
				unauthorizedText: '연결할 권한이 없습니다',
				allowedUsersText: '다음은 이 작업을 할 수 있는 개인 목록입니다',
				close: '닫기'
			},
			{
				stepName: '단계 4',
				stepDescription: 'Mercury/GFIS에 연결'
			},
			{
				stepName: 'Step 5',
				stepDescription: 'Associate engagement codes to EY Canvas engagements',
				isExit: true
			}
		],
		ratePerHour: '시간당 요율',
		realizationPercentage: '실현율'
	},
	stepOne: {
		enterProjectName: '계속하려면 프로젝트 이름을 입력하십시오'
	},
	stepTwo: {
		addCanvasEngagements: 'Add EY Canvas engagements to the project',
		editCanvasEngagements: 'Edit EY Canvas engagements to the project',
		selectCanvasEngagements: 'EY Canvas engagements that you have access to are displayed.  Select one or more EY Canvas engagements to be included in the project.',
		noCanvasEngagements: 'No EY Canvas engagements available. Proceed to the next step to continue project setup.',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: 'No results found',
		clientName: '고객',
		workspace: 'Workspace',
		engagementCode: 'Engagement 코드',
		canvasEngagementName: 'EY Canvas Engagement',
		changes: '변경사항',
		tooltipMessages: {
			clientName: '고객 이름',
			clientCode: '고객 코드',
			engagementCode: 'Engagement 코드',
			engagementDescription: 'Engagement 이름',
			workspaceID: 'Workspace ID',
			workspaceDescription: 'Workspace 이름'
		}
	},
	stepThree: {
		editTeamMembers: '프로젝트 팀 멤버 편집',
		editTeamMembersWhoWillHaveAccess: 'Edit team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		addTeamMembers: '프로젝트에 팀 멤버 추가',
		addTeamMembersWhoWillHaveAccess: 'Add team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: 'No results found',
		addOtherTeamMembers: 'Add other team members not part of the connected EY Canvas engagements',
		member: '멤버',
		projectAdministrator: '프로젝트 관리자',
		clickHere: '여기를 클릭하십시오',
		nameOrEmail: '이름 또는 이메일',
		addNewMember: '추가',
		firstName: '이름',
		lastName: '성',
		inviteAndClose: '초대 & 닫기',
		inviteAndAddAnother: '초대 & 더 추가',
		clear: '처리'
	},
	stepFour: {
		engagementCode: 'Engagement 코드',
		clientName: '고객',
		validation: '상태',
		independenceOnly: 'Independence only',
		noEngagementCodes: '프로젝트에 추가된 engagement 코드 없음',
		addNewMember: '추가',
		addEngagementManually: 'Engagement 코드 추가',
		addEngagementCodes: 'Engagement 코드 추가',
		editEngagementCodes: 'Engagement 코드 편집',
		validateEngagement: 'Validate all the engagement codes added. Only engagements codes that you have access to in GFIS/Mercury can be validated. If an engagement code is identified as \'Independence only\', details related to this engagement code (such as team members and related hours charged) will be included in the Independence summary of this Economics project but will not be included in the financial related information.',
		informationalMessage: 'Mercury는 engagement 코드 앞에 engagement 유형을 포함합니다 (예, E-12345678)',
		noCanvasEngagements: 'No EY Canvas engagements have been added to the project',
		engagementCodePlaceholder: 'Engagement 코드 입력',
		validate: '검증',
		engagementCodeRequired: 'Engagement 코드 필요',
		searchNoResults: "결과를 찾을 수 없습니다"
	},
	stepFive: {
		title: 'Associate engagement codes to EY Canvas engagements',
		description: "The primary engagement codes associated to each of the connected EY Canvas engagements are displayed below. To associate additional engagement codes to an EY Canvas engagement, use the below drag and drop functionality.",
		financialCodes: {
			searchButtonTitle: 'Search',
			searchButtonPlaceholder: 'Search by financial engagement code',
			header: 'Engagement codes',
			noRecords: 'No engagement codes identified',
			canvasEngagements: 'EY Canvas engagements',
			noResults: '결과를 찾을 수 없습니다'
		},        
		canvasEngagements: {
			searchButtonTitle: 'Search',
			clearButtonTitle: 'Clear',
			noResults: '결과를 찾을 수 없습니다',
			searchButtonPlaceholder: 'Search by Client or EY Canvas engagement',
			header: 'Clients and engagements',
			noRecords: 'No EY Canvas engagements associated to the project',
			noEngagementCodes: 'No associated engagement codes',
			primary: 'Primary',
			displayUnassociatedEngagements:'Display EY Canvas engagement(s) with no financial codes associated'
		}
	},
	deleteProject: '프로젝트 삭제',
	deleteDescription: '모든 사용자에 대해 프로젝트를 삭제하시겠습니까?',
	deleteDescText: '이 작업은 실행 취소할 수 없습니다.',
	delete: '삭제',
	cancel: '취소',
	close: '닫기',
	confirm: '확인',
	leaveProject: '나가기',
	leaveDescription: '이 프로젝트에서 나가시겠습니까? 팀 멤버는 계속 사용할 수 있습니다.',
	change: '변경',
	changes: '변경사항'
};

export const users = {
	settings: {
		title: '사용자 설정',
		firstName: '이름',
		lastName: '성',
		displayLanguage: '표시 언어',
		numberFormat: '숫자 형식',
		negativeNumberFormat: '음수 형식',
		currencyFormat: '통화 형식',
		dateFormat: '날짜 형식',
		roundingFormat: '반올림 형식',
		save: '저장',
		cancel: '취소',
		errorMessageSelect: '값을 선택하십시오',
		errorMessageInput: '유효한 값을 입력하십시오',
		isRequired: '은(는) 필수입니다',
		preferences: '기본 설정',
		yourDelegates: '귀하의 대리인',
		yourDelegatesDescription: '귀하가 접근할 수 있는 engagement 코드에 대한 재무 데이터를 Mercury 또는 GFIS에서 검색할 권한을 부여받은 사용자',
		delegationsFromOthers: '타인의 위임',
		delegationsFromOthersDescription: '그들이 접근할 수 있는 engagement 코드에 대한 재무 데이터를 Mercury 또는 GFIS에서 검색할 권한을 귀하에게 부여한 사용자',
		noUsersIdentified: '식별된 사용자 없음',
		addADelegate: '대리인 추가',
		theme: '테마',
		preferredCurrency: '기본 통화',
		status: '상태'
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: '고객 필터',
		filter: '필터',
		searchPlaceholder: '검색',
		searchClearHoverText: '처리',
		searchHoverText: '검색',
		unvalidated: '검증되지 않음',
		noData: 'No EY Canvas engagement associated',
		noResults: '결과를 찾을 수 없습니다',
		noInformationAvailable: '선택한 옵션에 사용 가능한 정보 없음',
		independence: 'Independence',
		noDataFound: 'No data found',
	},
	roundingType: '반올림:',
	roundingFormats: {
		none: '없음',
		thousands: '천',
		millions: '백만',
		lakhs: '십만',
		crores: '천만'
	},
	updatedDateType: {
		financialDateLabel: 'Financial data',
		updatedOn: 'updated on',
		canvasDateLabel: 'EY Canvas data'
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: 'TER',
			actualTER: '실제 TER',
			billed: '청구됨',
			actualBilling: '실제 청구',
			totalEngagementRevenue: '총 engagement 수익 (보수 + 비용)',
			forecastedTER: '예측 TER'
		},
		margin: {
			margin: '마진',
			target: '대상'
		},
		globalDeliveryService: {
			gds: 'GDS 사용',
			globalDeliveryService: 'Global Delivery Service'
		}
	},
	currency: '통화:',
	globalCurrency: 'Global',
	localCurrency: '로컬',
	noDataAvailable: '선택한 필터에 사용 가능한 데이터 없음',
	actualHours: '실제 시간',
	etc: 'ETC',
	ftaVariance: 'FTA 차이',
	completedTasks: '완료 task',
	closedAssignments: '닫힌 배정',
	acceptedRequests: '수락된 요청사항',
	gDSUsage: 'GDS 사용',
	summaryHeaderPartner: 'Partner',
	summaryHeaderPpedd: 'PPEDD',
	summaryHeaderExecutive: 'Executive',
	financialProgressCard: {
		financialProgress: '재무적 진행상태',
		financialDetails: '세부재무정보',
		ansr: 'ANSR',
		nsr: 'NSR',
		ansrTooltip: 'Adjusted net standard revenue (net fees excluding expenses)',
		nsrTooltip: 'Net standard revenue (individual net standard rates times hours)',
		eafTooltip: 'Engagement adjustment factor',
		cost: '원가',
		hours: '시간',
		expandDetails: '세부정보 확장',
		expand: '확장',
		collapse: 'Collapse',
		collapseDetails: 'Collapse details',
		margin: '마진',
		marginPercentage: '마진',
		rphAcronym: 'RPH',
		cphAcronym: 'CPH',
		mphAcronym: 'MPH',
		eafAcronym: 'EAF',
		actual: '실제',
		budgeted: '예산',
		forecasted: '예측',
		ftaVariance: 'FTA 차이',
		ftaVarianceTooltip: '예측 대 실적 차이',
		rph: '시간당 요율',
		cph: '시간당 원가',
		mph: '시간당 마진',
		ansrCost: 'NSR / Cost',
		serviceLine: '서비스라인',
		subServiceLine: '서브서비스라인',
		teamMember: '팀 멤버',
		totalAnsr: 'Total NSR',
		totalCost: '총 원가',
		totalHours: '총 시간',
		ansrLabelText: 'Net standard revenue',
		rank: '직급',
		performanceActuals: 'Performance actuals'
	},
	financialAnalysis: {
		show: '표시',
		first: '처음',
		last: '마지막',
		previous: '이전',
		next: '다음'
	},
	financialFilters: {
		serviceLine: '서비스라인',
		subServiceLine: '서브서비스라인',
		rank: '직급',
		teamMember: '팀 멤버',
		showMore: '기타',
		clear: '처리',
		clearAll: '모두 처리',
		search: '검색',
		noResultsPlaceholder: '결과 없음',
		noFiltersAvailable: '필터 없음',
		yes: '예',
		no: '아니오',
		tooltip: '필터',
		expenseType: 'Expense type',
		allocation: 'Allocation'
	},
	billingAndExpenses: {
		title: '실제 누적 청구',
		forecastedTer: '예측 TER',
		forecastedTerTooltip: 'Forecasted total engagement revenue (fees + expenses)',
		forecastedBilling: '예측 청구',
		collected: '회수됨',
		collectedTooltip:'Collected / Billed',
		unCollected: 'Uncollected',
		unCollectedTooltip:'Uncollected / Billed',
		billed: 'Billed (Outstanding)',
		billedTooltip:'Billed / Forecasted TER',
		billedTotal: 'Billed',
		unbilled: '미청구',
		unbilledTooltip: 'Unbilled / Forecasted TER',
		engagementCode: 'Engagement 코드',
		invoiceDate: 'Invoice date',
		currency: 'Currency',
		invoiceNumber: 'Invoice number',
		amount: 'Amount',
		noInformationPlaceholder: 'No information available for the selected options.',
		actualTer: 'Actual TER',
		actualTerTooltip: 'Actual total engagement revenue (fees + expenses)',
		actualExpenseToDate: 'Actual expenses to date',
		displayBy: '데이터 표시 기준',
		expenseType: 'Expense type',
		teamMember: '팀 멤버',
		totalExpenseToDate: 'Total expenses to date',
		expenseTypeColumn: 'Expense type',
		teamMemberColumn : 'Team member',
		globalExpenseAmount: 'Global expense amount',
		localExpenseAmount: 'Local expense amount',
		billingSummary: 'Billing summary',
		billingStatus: 'Billing status',
		billingTER: 'TER',
		serviceLine: '서비스라인',
		serviceLineColumn: 'Service line',
		rank: '직급',
		rankColumn : 'Rank',
		allocation: 'Allocation',
		allocationsExpense: 'Allocated expenses present',
	},
	independence: {
		teamMember: '팀 멤버',
		hoursCharged: 'Hours charged',
		independenceStatus: 'Overall independence status',
		confirmationDate: 'Confirmation date',
		memberFirm: 'Member firm',
		eyCanvasIndependenceStatus: 'EY Canvas independence status',
		employmentStatus: 'Employment status',
		country: 'Country',
		updatedBy: 'Updated by',
		updatedDate: 'Updated date',
		selectColumns: 'Select the columns',
		confirmationDateBefore: 'Confirmation date before',
		confirmationDateAfter: 'Confirmation date after',
		excelsummary: 'Summary',
		excelMercury: 'Data from Mercury',
		excelCanvas: 'Data from Canvas',
		name: 'Name',
		gui: 'GUI',
		rank: '직급',
		emailAddress: 'Email address',
		clarification: 'Clarification',
		explanation: 'Explanation',
		updatedOn: 'Updated on',
		client: 'Client',
		mercuryEngagementCode: 'Mercury engagement code',
		canvasEngagement: 'Canvas engagement',
		email: 'Email',
		reason: 'Reason',
		engagementRole: 'Engagement role',
		location: 'Location',
		employeeStatus: 'Employee status',
		noResultsPlaceholder: '결과를 찾을 수 없습니다',
		filter : {
			unassociatedFinancialCodes : 'Unassociated financial codes',
			unassociatedLabel : 'Unassociated',
			filterHeader: 'Independence filter',
			noFinancialCodeLabel: 'No financial code associated',
			noEngagementLabel: 'No EY Canvas engagement associated',
			expandText: 'Expand',
			collapseText: 'Collapse',
			noDataFound: 'No data found'
		}
	},
	header:{
		hours: '시간',
		actualHours: '실제',
		forecastedHours: '예측',
		variance: 'FTA variance',
		other: 'Other',
		ppedd: 'PPEDD',
		mgrSrMgr: 'SrMgr/Mgr',
		partnerHours: 'Partner 시간',
		executiveDirector: 'Executive Director',
		seniorManager: 'Senior Manager',
		manager: 'Manager',
		senior: 'Senior',
		staff: 'Staff',
		intern: 'Intern',
		billed: '청구됨:',
		ter: 'TER:',
		forecastedTER: '예측 TER:',
		margin: '마진',
		ansr: 'ANSR',
		cost: '원가',
		terSection: 'TER',
		billedSection: '청구됨',
		forecastedTERSection: '예측',
		forecastedTERSectionForHeader: 'Forecasted TER',
		completedTasks: '완료 task',
		completedAssignments: '닫힌 배정',
		acceptedRequests: '수락된 요청사항',
		gdsUsage: 'GDS 사용',
		completedTasksTooltip: '완료됨',
		totalTasksTooltip: '총',
		completedAssignmentsTooltip: '닫힘',
		totalAssignmentsTooltip: '총',
		acceptedRequestsTooltip: '수락됨',
		sentRequestsTooltip: '전송됨',
		gdsHoursTooltip: 'GDS',
		actualHoursTooltip: '실제 시간',
		otherTooltip: 'Other',
		otherHeaderTooltip: 'Other',
		ppeddTooltip: 'PPEDD',
		mgrSrMgrTooltip: 'SrMgr/Mgr',
		partnerHoursTooltip: 'Partner/Principal',
		executiveDirectorTooltip: 'ED/D',
		seniorManagerTooltip: 'Sr. Manager',
		managerTooltip: 'Manager',
		seniorTooltip: 'Senior',
		staffTooltip: 'Staff',
		internTooltip: 'Intern',
		varianceTooltip: 'Forecast to actual variance',
		ansrTooltip: 'Adjusted net standard revenue (net fees excluding expenses)',
		marginTooltip: 'Margin = (ANSR - Cost) / ANSR',
		terSectionHover: 'Actual total engagement revenue (fees + expenses)',
		forecastedTERSectionHover: 'Forecasted total engagement revenue (fees + expenses)',
		billedSectionHover: 'Actual net invoice amount',
		gdsUsageHover: 'Global Delivery Service usage'
	},
	allocationsFilters : [{
			value: 1,
			label: 'Yes'
		}
	]
};

export const exportOptions = {
	buttonText: '내보내기',
	downloadCSV: 'CSV 다운로드',
	downloadJPEG: 'JPEG 다운로드',
	downloadPDF: 'PDF 다운로드',
	downloadPNG: 'PNG 다운로드',
	downloadSVG: 'SVG 다운로드',
	downloadXLS: 'XLS 다운로드',
	exitFullscreen: '전체 화면 종료',
	viewFullscreen: '전체 화면 보기',
	printChart: '차트 인쇄'
};

export const adminLabels = {
	adminPortal: 'Administration',
	usersTab: 'Manage users',
	projectsTab: 'Manage projects',
	administrators: 'Manage administrators'
};

export const projectUserStatus = {
	active: 'Active',
	inactive: 'Inactive',
};

export const projectUserRoles = {
	defaultUser: 'Default user',
	projectAdministrator: '프로젝트 관리자'
};

export const projectStatus = {
	active: 'Active',
	deleted: 'Deleted'
};

export const administratorRoles = {
	none: '없음',
	adminReader: 'Admin reader',
	adminWriter: 'Admin writer',
	superAdmin: 'Super admin'
}

export const addUser = {
	firstName: '이름',
	lastName: '성',
	enterFirstNameText:'Enter first name, last name or email address of user and press enter to search',
	selectRole: 'Role',
	userRole: 'User role',
	clear: '처리',
	email: 'Email',
	role: '역할',
	cancel: '취소',
	addUser: 'Add User',
	close: '닫기',
	add: 'Add',
	addAdministrator: 'Add administrator',
	error1: 'The selected user is already a part of the project. Please review.',
	error2: 'Admin can only be priviledged user account'
};

export const adminManageProjects = {
	manageProjects: 'Manage projects',
	description: 'Search for a project by entering the project ID',
	projectId: 'Project ID',
	search: '검색',
	clearSearch: 'Clear',
	enterValidProject: 'Enter valid project ID',
	projectDetails: 'Project details',
	enterProjectName: 'Enter project name',
	projectName: 'Project name',
	projectStatus: 'Project status',
	financialCodes: 'Financial codes',
	noFinancialCodes: 'No financial engagement codes are mapped to this project',
	engagementCode: 'Engagement 코드',
	client: 'Client',
	status: '상태',
	validatedBy: 'Validated by',
	canvasEngagements: 'EY Canvas engagements',
	canvasEngagement: 'EY Canvas engagement',
	noCanvasEngagements: 'No EY Canvas engagements are mapped to this project',
	member: 'Members',
	gui: 'GUI',
	firstName: '이름',
	lastName: '성',
	emailAddress: 'Email address',
	userRole: 'User role',
	validated: 'Validated',
	unvalidated: '검증되지 않음',
	enterValidGui: 'Enter a valid GUI for project ID',
	requiredProjectName: 'Project name cannot be blank',
	successToastMessage: 'Changes saved successfully',
	resetToastMessage: 'Reset completed',
	errorToastMessage: 'At least one project member is required to be a Project administrator. Please review the changes.',
	independenceOnly: 'Independence only',
	yes: '예',
	no: '아니오'
};

export const manageAdministrators = {
	title: 'Manage administrators',
	firstName: '이름',
	lastName: '성',
	email: 'Email',
	role: '역할',
	description: 'Add new administrators or manage existing administrators',
	noInformationPlaceholder: 'No information available for the selected options.',
	updateAdminErrorToast: 'Update was unsuccessful. Please review and try again later.',
	updateAdminSuccessToast: 'Changes saved successfully',
};

export const adminManageUsers = {
	title : 'Manage users',
	description: 'Search for a user by entering their user GUI',
	inputLabel: 'User GUI',
	searchButtonLabel: 'Search',
	cancelButtonLabel: 'Clear',
	errorMessage: 'Enter a valid user GUI',
	userDetails: 'User details',
	projects: 'Projects',
	delegates: 'Delegates',
	settings: 'Settings',
	noResultsPlaceholder: 'No records found',
	delegatedTo: 'Delegated to:',
	delegatedFrom: 'Delegated from:',
	gui: 'GUI',
	firstName: '이름',
	lastName: '성',
	emailAddress: 'Email address',
	projectName: 'Project name',
	projectId: 'Project ID'
};

export const adminCommon = {
	save: '저장',
	reset: 'Reset'
}
